import React, { useEffect, useState } from "react";
import axios from "axios";

export default function SpaceContentEditModal({ item, onClose, onSave }) {
    const [eventName, setEventName] = useState(item.eventName || "");
    const [location, setLocation] = useState(item.location || "");

    const [keywords, setKeywords] = useState([]);
    const [themes, setThemes] = useState([]);

    const [selectedKeywords, setSelectedKeywords] = useState(item.keywords || []);
    const [selectedThemes, setSelectedThemes] = useState(item.themes || []);

    const [keywordInput, setKeywordInput] = useState("");
    const [themeInput, setThemeInput] = useState("");

    const [locationType, setLocationType] = useState(item.locationType || "");

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/space-content/keywords`)
            .then(res => setKeywords(res.data));
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/space-content/themes`)
            .then(res => setThemes(res.data));
    }, []);

    const toggle = (list, setList, value) => {
        setList(prev =>
            prev.includes(value)
                ? prev.filter(v => v !== value)
                : [...prev, value]
        );
    };

    const handleMultiInput = (value, setter, selectedSetter, selectedList) => {
        setter(""); // 입력창 초기화
        const entries = value
            .split(/[\s,]+/) // 공백 또는 쉼표 1개 이상을 기준으로 분리
            .map(e => e.trim())
            .filter(e => e.length > 0 && !selectedList.includes(e));
        if (entries.length > 0) {
            selectedSetter(prev => [...prev, ...entries]);
        }
    };

    const handleInputKeyDown = (e, inputValue, setInputValue, selectedSetter, selectedList) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            handleMultiInput(inputValue, setInputValue, selectedSetter, selectedList);
        }
    };

    const handleSave = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/space-content/edit/${item.id}`, {
                eventName,
                location,
                locationType, // ✅ 사용자 선택한 상태값을 전송
                keywords: selectedKeywords,
                themes: selectedThemes
            });
            alert('수정이 완료되었습니다')
            onSave(res.data);
        } catch (e) {
            alert("수정 실패");
        }
    };

    return (
        <div className="slow-animation fixed inset-0 bg-gray-500 bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white max-w-xl w-full p-6 rounded space-y-4">
                <div className="flex justify-between items-center">
                    <h2 className="text-xl font-bold">공간 콘텐츠 수정</h2>
                    <button onClick={onClose} className="text-red-600">닫기</button>
                </div>

                {/* 행사명 수정 */}
                <div>
                    <label className="block font-semibold mb-1">행사명</label>
                    <input
                        className="w-full border px-3 py-2 rounded"
                        value={eventName}
                        onChange={(e) => setEventName(e.target.value)}
                    />
                </div>

                {/* 실내 / 실외 선택 */}
                <div>
                    <label className="block font-semibold mb-1">장소 유형</label>
                    <div className="flex gap-4">
                        {["실내", "실외"].map((type) => (
                            <button
                                key={type}
                                onClick={() => setLocationType(type)}
                                className={`border px-4 py-1 rounded ${
                                    locationType === type ? "bg-blue-600 text-white" : "bg-gray-100"
                                }`}
                            >
                                {type}
                            </button>
                        ))}
                    </div>
                </div>

                {/* 장소명 수정 */}
                <div>
                    <label className="block font-semibold mb-1">장소명</label>
                    <input
                        className="w-full border px-3 py-2 rounded"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                    />
                </div>

                {/* 키워드 입력 및 토글 */}
                <div>
                    <label className="block font-semibold mb-1">키워드</label>
                    <div className="flex flex-wrap gap-2 mb-2">
                        {selectedKeywords.map((k, i) => (
                            <button
                                key={i}
                                onClick={() => toggle(selectedKeywords, setSelectedKeywords, k)}
                                className={`px-3 py-1 rounded-full border text-sm ${
                                    selectedKeywords.includes(k)
                                        ? "bg-blue-600 text-white"
                                        : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                                }`}
                            >
                                {k}
                            </button>
                        ))}
                    </div>
                    <input
                        type="text"
                        name="keyword"
                        value={keywordInput}
                        onChange={(e) => setKeywordInput(e.target.value)}
                        onKeyDown={(e) =>
                            handleInputKeyDown(e, keywordInput, setKeywordInput, setSelectedKeywords, selectedKeywords)
                        }
                        className="w-full border px-3 py-2 rounded"
                        placeholder="새 키워드를 입력하고 Enter"
                    />
                </div>

                {/* 행사 성격 입력 및 토글 */}
                <div>
                    <label className="block font-semibold mb-1">행사 성격</label>
                    <div className="flex flex-wrap gap-2 mb-2">
                        {selectedThemes.map((t, i) => (
                            <button
                                key={i}
                                onClick={() => toggle(selectedThemes, setSelectedThemes, t)}
                                className={`px-3 py-1 rounded-full border text-sm ${
                                    selectedThemes.includes(t)
                                        ? "bg-green-600 text-white"
                                        : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                                }`}
                            >
                                {t}
                            </button>
                        ))}
                    </div>
                    <input
                        type="text"
                        name="theme"
                        value={themeInput}
                        onChange={(e) => setThemeInput(e.target.value)}
                        onKeyDown={(e) =>
                            handleInputKeyDown(e, themeInput, setThemeInput, setSelectedThemes, selectedThemes)
                        }
                        className="w-full border px-3 py-2 rounded"
                        placeholder="새 행사 성격 입력 후 Enter"
                    />
                </div>

                <div className="flex justify-end mt-4">
                    <button
                        onClick={handleSave}
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                    >
                        저장
                    </button>
                </div>
            </div>
        </div>
    );
}